import bingoTable from './index.vue';
export default bingoTable;



// WEBPACK FOOTER //
// ./src/components/bingo-table/index.js